import type { Pbx } from '@mangovoice/types'

const HOSPITALITY_INDUSTRY = 'hospitality'

interface HotelsExperienceParams {
  pbx?: Pick<Pbx, 'industry_type'> | null
}

export const isHospitalityIndustryType = (
  industryType?: string | null,
): boolean =>
  typeof industryType === 'string' &&
  industryType.trim().toLowerCase() === HOSPITALITY_INDUSTRY

export const isHospitalityPbx = (
  pbx?: Pick<Pbx, 'industry_type'> | null,
): boolean => isHospitalityIndustryType(pbx?.industry_type)

export const shouldUseHotelsExperience = ({
  pbx,
}: HotelsExperienceParams): boolean => isHospitalityPbx(pbx)
